import { render, staticRenderFns } from "./SubCategoryDetails.vue?vue&type=template&id=1debf8c2&"
import script from "./SubCategoryDetails.vue?vue&type=script&lang=js&"
export * from "./SubCategoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoryDetails.vue?vue&type=style&index=0&id=1debf8c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports